import validate from 'validate.js'

const constraints = {
  educatorId: {
    presence: true
  },
  blocks: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
